import { AccountValue, AccountValueWithId } from './VersionHistoryPopupContent.types';

export const mapAccountValues = (accountValue: AccountValue): AccountValueWithId => ({
    ...accountValue,
    id: accountValue.fieldValueId || '',
});
